var React = require('react');

function TriangleCenterDark (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"fill":"#394656","fillRule":"evenodd","points":"112 0 202 138 23 138","transform":"translate(-23)"}));
}

TriangleCenterDark.defaultProps = {"width":"179","height":"138","viewBox":"0 0 179 138"};

module.exports = TriangleCenterDark;

TriangleCenterDark.default = TriangleCenterDark;
